module.exports = __webpack_public_path__ + "img/7.9f6a7549.webp";